import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import registerRequest from "./register-request.service";
import acceptedRegisterRequest from "./accepted-register-request/accepted-register-request";
import rejectRegisterRequest from "./reject-register-request/reject-register-request";

let mod = angular
    .module('RegisterRequests.component', [
        angularUIB,
        core,
        registerRequest,
        rejectRegisterRequest,
        acceptedRegisterRequest
    ])
    .component('registerRequestsControl', {
        template: require('./register-requests-control.component.html'),
        controller: ['notifier', '$uibModal', 'Auth', 'Data', 'RegisterRequest', controller],
        bindings: {
            params: '<',
            roles: '<',
            agregator: '<',
            activeInvitesCount: '<',
            newRegisterRequests: '<'
        }
    });

function controller(notifier, $uibModal, Auth, Data, RegisterRequest) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.currentPage = 1;
        $ctrl.id = null;
        $ctrl.search = null;
        $ctrl.organization = null;
        $ctrl.status = null;

        if ($ctrl.params.id) {
            $ctrl.id = $ctrl.params.id;
        }

        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.getOrganizations = function (fragment) {
        return Data.getOrganizations(fragment);
    };

    $ctrl.getList = function () {
        RegisterRequest
            .getList({
                currentPage: $ctrl.currentPage,
                id: $ctrl.id,
                search: $ctrl.search,
                organization_bin: $ctrl.organization ? $ctrl.organization.bin : null,
                status: $ctrl.status
            })
            .then(
                function (response) {
                    $ctrl.registerRequests = response.data.registerRequests;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.accepted = function (registerRequest) {
        $uibModal
            .open({
                component: 'acceptedRegisterRequest',
                resolve: {
                    registerRequest: function () {
                        return registerRequest;
                    },
                    roles: function () {
                        return $ctrl.roles;
                    },
                    agregator: function () {
                        return $ctrl.agregator;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    registerRequest.status = 'accepted';
                    registerRequest.user_id = result.id;
                },
                function () {}
            );
    };

    $ctrl.reject = function (registerRequest) {
        $uibModal
            .open({
                component: 'rejectRegisterRequest',
                resolve: {
                    registerRequest: function () {
                        return registerRequest;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    registerRequest.status = 'rejected';
                    registerRequest.reject_reason = result.comment;
                },
                function () {}
            );
    };

    $ctrl.showRejectReason = function (registerRequest) {
        notifier.errorNotify(registerRequest.reject_reason);
    };
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/register-requests-control/register-requests-control.component.js